import { render, staticRenderFns } from "./SelectedPackage.vue?vue&type=template&id=b56c9056"
import script from "./SelectedPackage.vue?vue&type=script&lang=js"
export * from "./SelectedPackage.vue?vue&type=script&lang=js"
import style0 from "./SelectedPackage.vue?vue&type=style&index=0&id=b56c9056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports